import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './core/components/Layout';
import { ProtectedRoute } from './core/components/ProtectedRoute';
import { AuthProvider } from './core/contexts/AuthContext';
import { theme } from './core/theme';
import { AuthCallbackPage } from './features/auth/AuthCallbackPage';
import { LoginPage } from './features/auth/LoginPage';
import { TwitterCallbackPage } from './features/auth/TwitterCallbackPage';
import { DashboardPage } from './features/dashboard/DashboardPage';
import { LPPage } from './features/lp/LPPage';
import { ProfilePage } from './features/profile/ProfilePage';
import { TimelinePage } from './features/timeline/TimelinePage';

const hostname = window.location.hostname;
const isProduction = hostname === 'collect.runport.run';
const isDev = hostname === 'dev-collect.runport.run';

// dot99 の Google OAuth Client ID（HeraldingEra と共用）
const googleClientId = isProduction
  ? '281512048896-8976la8dp9qr60uvv134p31muck38nqt.apps.googleusercontent.com'
  : '1065437798827-2o9p05fjr4424vu0lvv7jarribnrahl5.apps.googleusercontent.com';

function App() {
  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              {/* 認証不要ページ */}
              <Route path="/" element={<LPPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/auth/callback" element={<AuthCallbackPage />} />

              {/* 認証必須ページ（Layout でヘッダー + ドロワー付き） */}
              <Route element={<ProtectedRoute />}>
                <Route element={<Layout />}>
                  <Route path="/dashboard" element={<DashboardPage />} />
                  <Route path="/profile" element={<ProfilePage />} />
                  <Route path="/timeline" element={<TimelinePage />} />
                  <Route path="/wallet" element={<Navigate to="/profile" replace />} />
                  <Route path="/auth/twitter/callback" element={<TwitterCallbackPage />} />
                </Route>
              </Route>
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
